{
  "name": "albina-admin-gui",
  "version": "9.0.0-51-gfe197b2c6",
  "private": true,
  "description": "Admin user interface for avalanche bulletins.",
  "bugs": {
    "url": "https://gitlab.com/albina-euregio/albina-admin-gui"
  },
  "license": "AGPL-3.0-or-later",
  "author": "Norbert Lanzanasto",
  "repository": {
    "type": "git",
    "url": "git@gitlab.com:albina-euregio/albina-admin-gui.git"
  },
  "scripts": {
    "ng": "ng",
    "start": "node scripts/use-env.mjs local && ng serve",
    "start-local": "node scripts/use-env.mjs local && ng serve --configuration development",
    "start-dev": "node scripts/use-env.mjs dev && ng serve --configuration development",
    "start-beta": "node scripts/use-env.mjs beta && ng serve",
    "start-aran": "node scripts/use-env.mjs aran && ng serve",
    "prebuild": "node scripts/use-env.mjs local",
    "build": "ng build",
    "dev": "node scripts/use-env.mjs dev && ng serve --configuration development",
    "watch": "node scripts/use-env.mjs dev && ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "playwright": "NODE_OPTIONS=--disable-warning=DEP0205 playwright test",
    "prepare": "vp config",
    "openapi": "pnpm exec openapi-ts && vp fmt src/app/providers/albina-api/ && node scripts/zod-describe.mjs",
    "changelog": "git-cliff --unreleased --prepend CHANGELOG.md --tag",
    "changelog-latest": "git-cliff --latest --prepend CHANGELOG.md"
  },
  "dependencies": {
    "@albina-euregio/linea": "^8.24.2",
    "@angular/cdk": "^22.0.2",
    "@angular/common": "^22.0.2",
    "@angular/compiler": "^22.0.2",
    "@angular/core": "^22.0.2",
    "@angular/forms": "^22.0.2",
    "@angular/platform-browser": "^22.0.2",
    "@angular/platform-browser-dynamic": "^22.0.2",
    "@angular/router": "^22.0.2",
    "@angular/upgrade": "^22.0.2",
    "@auth0/angular-jwt": "^5.2.0",
    "@eaws/micro-regions": "^8.4.0",
    "@eaws/micro-regions_names": "^8.4.0",
    "@eaws/outline_properties": "^8.4.0",
    "@eaws/pmtiles": "^8.4.0",
    "@ngx-translate/core": "^18.0.0",
    "@phosphor-icons/web": "^2.1.1",
    "@popperjs/core": "^2.11.8",
    "air-datepicker": "^3.6.0",
    "bootstrap": "^5.3.7",
    "diff-match-patch": "^1.0.5",
    "echarts": "^6.0.0",
    "es-toolkit": "^1.44.0",
    "file-saver": "^2.0.5",
    "maplibre-gl": "^5.24.0",
    "mousetrap": "^1.6.5",
    "ngx-bootstrap": "^21.2.1",
    "ngx-echarts": "^22.0.0",
    "ngx-image-compress": "^18.1.5",
    "ngx-quill": "^31.0.0",
    "pmtiles": "^4.4.1",
    "quill": "^2.0.3",
    "rxjs": "7.8.2",
    "simple-statistics": "^7.8.7",
    "split.js": "^1.6.5",
    "temporal-polyfill": "^1.0.1",
    "which-polygon": "^2.2.1",
    "zod": "^4.4.3",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^22.0.3",
    "@angular-devkit/schematics": "^22.0.3",
    "@angular/build": "^22.0.3",
    "@angular/cli": "^22.0.3",
    "@angular/compiler-cli": "^22.0.2",
    "@eslint/js": "^10.0.1",
    "@hey-api/openapi-ts": "^0.99.0",
    "@playwright/test": "^1.61.1",
    "@types/diff-match-patch": "^1.0.36",
    "@types/file-saver": "^2.0.5",
    "@types/geojson": "^7946.0.14",
    "@types/mousetrap": "^1.6.15",
    "@types/node": "^25.9.3",
    "@types/which-polygon": "^2.2.3",
    "angular-eslint": "^22.0.0",
    "dotenv": "^17.2.2",
    "eslint": "^10.1.0",
    "git-cliff": "^2.7.0",
    "istanbul-lib-instrument": "^6.0.3",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.61.1",
    "vite-plus": "catalog:"
  },
  "resolutions": {
    "@types/css-font-loading-module": "^0.0.13"
  },
  "packageManager": "pnpm@11.17.0",
  "angular-cli": {},
  "copyright": "Copyright 2017 Norbert Lanzanasto",
  "url": "https://avalanche.report/"
}
